exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".login.component {\n  display: flex;\n  flex:1;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  background-color: #020202;\n}\n\n.login.component .wrapper{\n  min-width: 60px;\n  max-width: 200px;\n  width: 100%;\n  padding: 12px;\n  text-align: center;\n  z-index: 100;\n}\n\n.login.component .wrapper button {\n  width: 100%;\n  height: 32px;\n}\n\n.login.component .logo-wrapper {\n  margin-bottom: 30px !important;\n  width: 100%;\n}\n\n.login.component img{\n  width:60%;\n  height:auto;\n  opacity: 0.9;\n}\n\n.login.component img.brand-logo{\n  width:100%;\n  height:auto;\n  opacity: 1;\n}\n\n.login.component video{\n  min-height: 100%;\n  min-width: 100%;\n  width: auto;\n  height: auto;\n  overflow: hidden;\n}\n\n\n.login.component .login-error{\n  color: #FFFFFF;\n}\n\n.login.component .chrome-message{\n  color: #FFFFFF;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/component/login/styles.css
// module id = 248
// module chunks = 0